<template>
  <div>
    <el-row v-if="type" :gutter="20">
      <el-col :sm="{ span: 6}" v-bind:class="mobileSelected">
        <list :listData="getCatelog[type]" v-loading="!getCatelog[0]" @select="handleSelect"/>
      </el-col>
      <el-col ref="col" :sm="{ span: 18}">
        <router-view :itemId="selectedItemId"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import List from '@/components/List'
import { mapGetters } from 'vuex'
export default {
  props: ['type', 'id'],
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    handleSelect(item) {
      this.$router.push({ path: `/catalog/${this.type}/${item.Id}` })
    }
  },
  watch: {
    id: {
      handler: 'selectId'
    }
  },
  components: {
    List
  },
  computed: {
    ...mapGetters(['getCatelog']),
    selectedItemId() {
      return this.$route.params.itemId
    },
    mobileSelected() {
      const isSelected = this.selectedItemId
      return { 'hidden-xs-only': isSelected }
    }
  }
}
</script>
<style scoped>
